import { Array } from 'stdlib/Array'

import type { TBrowser } from '../definitions'
import { BROWSERS } from '../definitions'

/**
 * Browser elkérése.
 * @param browser - Browser típusa.
 */
export default function getBrowser (browser: string | undefined): TBrowser {
  if (Array.includes(BROWSERS, browser)) {
    return browser as TBrowser
  }

  return undefined
}
